import { useDecision } from '@optimizely/react-sdk';
export const FEATURE_FLAGS = {
  PERKS: 'perks',
  PERK_SELECTION_TOGGLE: 'perkselectiontoggle',
  PERK_STATUS_TOGGLE:'is_perks_status_enabled',
  PREMIUM_CARD_FEATURE: 'is_premium_card_feature_enabled',
  MEMBER_V3_FEATURE: 'is_getmemberinfo_v3_enabled',
  IS_NEW_BRANDING_ENABLED: 'is_atmos_branding_enabled',
  FOOD_VOUCHER_FEATURE: 'is_food_voucher_enabled'
};
 
export const useFeatureDecision = () => {
  const [decision] = useDecision(FEATURE_FLAGS.PERKS, {
    autoUpdate: true,
  });
 
  return {
    isMilestoneEnabled: (milestoneId: string) => decision.variables[(decision.variables.variableMap as any)?.milestoneFlags[milestoneId]] ?? false,
    isPerkEnabled: (perkName: string) => decision.variables[perkName] ?? decision.variables[(decision.variables.variableMap as any)?.perkFlags[perkName]] ?? false,
    isRewardHubEnabled: decision.variables['Is_RewardHub'] as boolean ?? false,
  };
}

export const useRewardHubFeatureDecision = () => {
  const [decision] = useDecision(FEATURE_FLAGS.IS_NEW_BRANDING_ENABLED, {
    autoUpdate: true
  });

  const enabled = (decision.enabled 
    && decision.variables['is_rewardhub_enabled'] as boolean) ?? false;

  return {
    isRewardHubEnabled: enabled,
  }
}

export const usePerkStatusFlag = (perkName:string) =>{
  const [perkStatusDecision] = useDecision(FEATURE_FLAGS.PERK_STATUS_TOGGLE, {
    autoUpdate: true
  });
 
  return perkStatusDecision.variables[perkName];
}
export const usePerkSelectionFlag = () =>{
  const [perkSelectionDecision] = useDecision(FEATURE_FLAGS.PERK_SELECTION_TOGGLE, {
    autoUpdate: true
  });
  return perkSelectionDecision.enabled;
}

export const usePremiumCardFlag = () =>{
  const [premiumCardDecision] = useDecision(FEATURE_FLAGS.PREMIUM_CARD_FEATURE, {
    autoUpdate: true
  });
  return premiumCardDecision.enabled;
};

export const useMemberV3Flag = () => {
  const [memberV3Decision] = useDecision(FEATURE_FLAGS.MEMBER_V3_FEATURE, {
    autoUpdate: true
  });
  return memberV3Decision.enabled;
};

export const useFoodVoucherFlag = () => {
  const [decision] = useDecision(FEATURE_FLAGS.FOOD_VOUCHER_FEATURE, {
    autoUpdate: true
  });
  return decision.enabled;
};
